const getScreenClass = (screenClass: string) => {
  const isMobile = screenClass === "xs";
  const isTablet = screenClass === "sm";
  const isDesktop = !isMobile && !isTablet;

  return { isMobile, isTablet, isDesktop };
};

export { getScreenClass };
